var React = require('react');

function CheckmarkRoundLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36.593 13.195a1 1 0 01.212 1.398l-14 19a1 1 0 01-1.43.188l-10-8a1 1 0 111.25-1.562l9.187 7.35 13.383-18.162a1 1 0 011.398-.212z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.816 1.827a24 24 0 1118.368 44.346A24 24 0 0114.816 1.827zM24 2a22 22 0 100 44 22 22 0 000-44z","key":1})]);
}

CheckmarkRoundLight.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = CheckmarkRoundLight;

CheckmarkRoundLight.default = CheckmarkRoundLight;
